import React, { useState } from 'react';
import {
  FaBars,
  FaTimes,
  FaGithub,
  FaLinkedin,
  FaWhatsapp
} from 'react-icons/fa';
// import { HiOutlineMail } from 'react-icons/hi';
import { BsFillPersonLinesFill, BsArrowUpSquare } from 'react-icons/bs';
import { Link } from 'react-scroll';

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const handleClick = () => setNav(!nav);

  const scrollTop = () => {
    window.scrollTo(0, 0)
  }
  return (
    <div className='fixed w-full h-[80px] flex justify-center items-center px-[2.5rem] bg-[#0a192f] text-gray-300 z-[999]'>
      <BsArrowUpSquare onClick={scrollTop} size={30} className='fixed bottom-5 right-5 cursor-pointer opacity-70' />
      {/* <div className='items-center h-full flex md:hidden'>
        <MdOutlineLaptopMac size={25} className='' />
        <p className='pl-3 font-semibold'></p>
      </div>
      <div className='items-center h-full hidden md:flex'>
        <MdOutlineLaptopMac size={40} className='' />
        <p className='pl-3 font-semibold'></p>
      </div> */}

      {/* menu */}
      <ul className='hidden md:flex'>
        <li className='font-semibold'>
          <Link to='home' smooth={true} duration={500}>
            Home
          </Link>
        </li>
        <li className='font-semibold'>
          <Link to='about' smooth={true} duration={500}>
            About
          </Link>
        </li>
        <li className='font-semibold'>
          <Link to='skills' smooth={true} duration={500}>
            Skills
          </Link>
        </li>
        <li className='font-semibold'>
          <Link to='work' smooth={true} duration={500}>
            Work
          </Link>
        </li>
        <li className='font-semibold'>
          <Link to='contact' smooth={true} duration={500}>
            Contact
          </Link>
        </li>
      </ul>

      {/* Hamburger */}
      <div onClick={handleClick} className='md:hidden z-10 flex w-full justify-end'>
        {!nav ? <FaBars size={25} /> : <FaTimes size={25} />}
      </div>

      {/* Mobile menu */}
      <ul
        className={
          !nav
            ? 'hidden'
            : 'absolute top-0 left-0 w-full h-screen bg-[#0a192f] flex flex-col justify-center items-center'
        }
      >
        <li className='py-6 text-4xl'>
          <Link onClick={handleClick} to='home' smooth={true} duration={500}>
            Home
          </Link>
        </li>
        <li className='py-6 text-4xl'>
          {' '}
          <Link onClick={handleClick} to='about' smooth={true} duration={500}>
            About
          </Link>
        </li>
        <li className='py-6 text-4xl'>
          {' '}
          <Link onClick={handleClick} to='skills' smooth={true} duration={500}>
            Skills
          </Link>
        </li>
        <li className='py-6 text-4xl'>
          {' '}
          <Link onClick={handleClick} to='work' smooth={true} duration={500}>
            Work
          </Link>
        </li>
        <li className='py-6 text-4xl'>
          {' '}
          <Link onClick={handleClick} to='contact' smooth={true} duration={500}>
            Contact
          </Link>
        </li>
      </ul>

      {/* Social icons */}
      <div className='hidden md:flex fixed flex-col top-[35%] left-0'>
        <ul>
          <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-blue-600'>
            <a
              className='flex justify-between items-center w-full text-gray-300'
              target='blank'
              href='https://www.linkedin.com/in/ryanagungsamudra'
            >
              Linkedin <FaLinkedin size={30} />
            </a>
          </li>
          <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#333333]'>
            <a
              className='flex justify-between items-center w-full text-gray-300'
              target='blank'
              href='http://github.com/ryanagungsamudra/'
            >
              Github <FaGithub size={30} />
            </a>
          </li>
          <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#6fc2b0]'>
            <a
              className='flex justify-between items-center w-full text-black/60'
              target='blank'
              href='https://wa.me/6282284798890'
            >
              WhatsApp <FaWhatsapp size={30} />
            </a>
          </li>
          <li className='w-[160px] h-[60px] flex justify-between items-center ml-[-100px] hover:ml-[-10px] duration-300 bg-[#565f69]'>
            <label
              htmlFor="cv-modal"
              className='flex justify-between items-center w-full text-gray-300 cursor-pointer'
            >
              Resume <BsFillPersonLinesFill size={30} />
            </label>
            {/* Put this part before </body> tag */}
            <input type="checkbox" id="cv-modal" className="modal-toggle" />
            <label htmlFor="cv-modal" className="modal cursor-pointer">
              <label className="modal-box relative max-w-[832px] p-0 rounded-none" htmlFor="">
                <iframe title='cv' src="https://drive.google.com/file/d/1mSVmCfJ-Jq_he6-1B_E58cirH5sjkHZS/preview" width="832" height="480" allow="autoplay"></iframe>
              </label>
            </label>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
